export function formatScore(score: number) {
  return new Intl.NumberFormat("hu-HU").format(score);
}
